import { Showcase } from 'app/src/features/Showcase/Showcase'
import { isDiscount } from 'app/src/shared/helpers'
import { type ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'

export function ShowcaseContainer(): ReactElement {
  const [searchParams] = useSearchParams()

  const showCaseKey = isDiscount(searchParams) ? 'discount' : 'welfare'

  return <Showcase key={showCaseKey} />
}
